// #568 — public-site attribution, the LMS side.
//
// Every link from the marketing site (f2cacademy.com) into the LMS carries the
// site's visitor id and its FIRST-touch values:
//   ?vid=<uuid>&utm_source=..&utm_medium=..&utm_campaign=..&utm_content=..&utm_term=..&ref=<host>&land=<path>
// We keep them in localStorage the moment any page loads, so they survive the
// redirect to /register and the Google OAuth round-trip (which wipes the URL).
// After sign-in, AuthContext sends them on /api/users/sync, which stamps
// users.site_visitor_id / users.signup_attribution only while still null.
//
// First touch wins here too: once stored, a later link never overwrites it.
// Nothing identifying is read: just what the link itself carries.

const KEY = 'f2c:attribution';
const UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const clip = (v, max) => {
  const s = (v || '').trim();
  return s && s.length <= max ? s : null;
};

/** The attribution a URL's query carries, or null when it carries none. Pure. */
export function attributionFromSearch(search) {
  let params;
  try {
    params = new URLSearchParams(search || '');
  } catch {
    return null;
  }
  const out = {};
  const vid = (params.get('vid') || '').trim();
  if (UUID.test(vid)) out.vid = vid.toLowerCase();
  for (const k of UTM) {
    const v = clip(params.get(k), 100);
    if (v) out[k] = v;
  }
  const ref = clip(params.get('ref'), 200);
  if (ref && /^[a-z0-9.:-]+$/i.test(ref)) out.ref = ref.toLowerCase();
  const land = clip(params.get('land'), 300);
  if (land && land.startsWith('/') && !land.startsWith('//')) out.land = land;
  if (!out.vid && !UTM.some((k) => out[k])) return null;   // ref/land alone say nothing
  return { ...out, at: new Date().toISOString() };
}

export function getStoredAttribution() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

/** Read the current URL and keep its attribution, unless some is kept already. Safe anywhere. */
export function captureAttributionFromUrl(search = typeof window !== 'undefined' ? window.location.search : '') {
  try {
    if (getStoredAttribution()) return;
    const found = attributionFromSearch(search);
    if (found) localStorage.setItem(KEY, JSON.stringify(found));
  } catch {
    /* no-op: private mode, storage full */
  }
}

/** Handed to the backend: forget it, so a second person on this browser does not inherit it. */
export function clearStoredAttribution() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}
